import isPrimaryCountry from "@/helpers/locations/primaryCountry";

const getStateValidationRules = (countryName: string): string | undefined => {
  if (isPrimaryCountry(countryName)) {
    return "required";
  }
}

export default getStateValidationRules;